/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bp_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why does pressure change the boiling point?`)
};

const es_bp_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Por qué la presión cambia el punto de ebullición?`)
};

const de_bp_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warum verändert der Druck den Siedepunkt?`)
};

const nl_bp_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waarom verandert druk het kookpunt?`)
};

const fr_bp_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pourquoi la pression change-t-elle le point d'ébullition ?`)
};

const it_bp_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perché la pressione cambia il punto di ebollizione?`)
};

const pt_br2_bp_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por que a pressão altera o ponto de ebulição?`)
};

const pt_bp_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porque é que a pressão altera o ponto de ebulição?`)
};

const ja_bp_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`なぜ圧力によって沸点が変わるのですか?`)
};

const zh_bp_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为什么压力会改变沸点？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bp_faq_q1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bp_faq_q1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bp_faq_q1", locale)
	if (locale === "en") return en_bp_faq_q1(inputs)
	if (locale === "es") return es_bp_faq_q1(inputs)
	if (locale === "de") return de_bp_faq_q1(inputs)
	if (locale === "nl") return nl_bp_faq_q1(inputs)
	if (locale === "fr") return fr_bp_faq_q1(inputs)
	if (locale === "it") return it_bp_faq_q1(inputs)
	if (locale === "pt-BR") return pt_br2_bp_faq_q1(inputs)
	if (locale === "pt") return pt_bp_faq_q1(inputs)
	if (locale === "ja") return ja_bp_faq_q1(inputs)
	return zh_bp_faq_q1(inputs)
};